const getValueByPath = (obj, path) => {
  try {
    const segments = path.split('.');
    for (let i = 0; i < segments.length; i++) {
      if (obj == null) {
        return "";
      }
      obj = obj[segments[i]];
    }
    return obj === undefined ? "" : obj;
  } catch (err) {
    return "";
  }
};

export default getValueByPath;
